import axios from '@/axios.js'

export default {
  getWeatherForecast: async (resortUuid) => {
    try {
      const response = await axios.editorapi.get(`v4/weatherforecast/${resortUuid}`)
      return response.data.object
    } catch (error) {
      throw new Error(error)
    }
  }
}
